import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import EmployeesList from 'employees/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const EmployeesListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  columnSearch,
  ///////
  handleToggle = () => {},
  ///////
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  handleToggleSearch = () => {}, // Agregar
  handleExport = () => {},
  t,
}) => {
  const handleExportCSV = (e) => {
    e.preventDefault();
    handleExport();
  };
  return (
    <Common.Wrapper fluid={true}>
      {/* <EmployeesList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.employees.add"]}
        handleExport={handleExport}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('employees.title')}
          icon={'users'}
          button={
            <div className="btn-group pull-right m-0">
              {permissions['acl.employees.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'employees/add')}
                  className="btn btn-info mr-3"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
              <Common.Dropdown>
                <Common.DropdownElement onClick={handleExportCSV}>
                  <i className="fa fa-table mr-2" />
                  {'  '}
                  {t('actions.exportCSV')}
                </Common.DropdownElement>
              </Common.Dropdown>
            </div>
          }
          buttonTwo={
            <EmployeesList.Filters
              handleSubmit={handleSubmit}
              handleValueChange={handleFiltersChange}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <EmployeesList.Table
              ////////
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              ////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </EmployeesList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(EmployeesListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/EmployeesListView.js